import { useQuery } from '@tanstack/react-query'
import { useNotification } from '../context/NotificationManager/NotificationManager'
import { getEventosHoy } from '../utils/api/eventos'

const useSideMenu = () => {
  const notification = useNotification()
  const { data: eventos = [] } = useQuery({
    queryKey: ['interno', 'eventos-calendario', 'list', 'today'],
    queryFn: () =>
      getEventosHoy().catch(err => {
        notification.error({
          title: 'Error al recuperar los eventos del día',
          content: err
        })
        return []
      }),
    refetchInterval: 15 * 60 * 1000
  })

  return {
    calendario: eventos.length
  }
}

export default useSideMenu
